// pop-up
$(document).ready(function () {
  $(".open1").click(function () {
    $(".pop-outer1").fadeTo(200, 1);
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut(200);
    $('body').removeClass('pp_popup_open');
  });
});

$(document).ready(function () {
  $(".open2").click(function (event) {
    var klarnaLink = $(event.target).closest("a.js-klarna-popup");
    if (klarnaLink.length && klarnaLink.attr("href") && klarnaLink.attr("href") !== "#") {
      return;
    }
    $(".pop-outer2").fadeIn("slow");
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow");
    $('body').removeClass('pp_popup_open');
  });
});

$(document).ready(function () {
  $(".open3").click(function (event) {
    var clearpayLink = $(event.target).closest("a.js-afterpay-popup");
    if (clearpayLink.length && clearpayLink.attr("href") && clearpayLink.attr("href") !== "#") {
      return;
    }
    $(".pop-outer3").fadeIn("slow");
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow");
    $('body').removeClass('pp_popup_open');
  });
});